export default ({ app, store, route }, inject) => {
  store.subscribe((mutation) => {
    if (mutation.type === '_core/auth/SIGNOUT' && app.$handTalk.existInstance()) {
      this.destroy();
    }

    /**
     * @deprecated Remove this in favor of using the query string disableHandtalk
    */
    try {
      const isWithinAFrame = window.parent !== window;

      if (isWithinAFrame && window.parent.$nuxt?.$handTalk?.existInstance() && app.$handTalk.existInstance()) {
        console.warn('You are currently using HandTalk inside an iframe. Consider including the "disableHandtalk" in the iframe URL to disable it');
        app.$handTalk.destroy();
      }
    } catch (nre) {
      // Cannot get window.parent from cross-domain
    }
  });

  inject('handTalk', {
    existInstance() {
      return !!app.handTalk;
    },
    start(value) {
      if (value && route.query.disableHandtalk !== 'true' && !this.existInstance()) {
        app.handTalk = new window.HT({
          token         : process.env.HAND_TALK_TOKEN,
          avatar        : 'MAYA',
          maxTextSize   : 1000,
          clickables    : ['.v-list-item--link', '.v-card--link'],
          addonsEnabled : false,
          align         : 'top',
          mobileConfig  : {
            actionsAlign      : 'top',
            customButtonStyle : {
              borderRadius     : '6px',
              bottomMargin     : '60px',
              horizontalMargin : '4.4vw',
              size             : '40px'
            }
          }
        });
      } else if (!value && this.existInstance()) {
        this.destroy();
      }
    },
    destroy() {
      app.handTalk.destroy();
      app.handTalk = null;
    },
    addListenersToIframes() {
      if (this.existInstance()) {
        app.handTalk.addListenersToIframes();
      }
    },
    removeListenersFromIframes() {
      if (this.existInstance()) {
        app.handTalk.removeListenersFromIframes();
      }
    }
  });
};
